import { CHART_COLORS } from '@forge/charts';
import type { DashboardStatus } from '@/api/dashboard';

export interface StatusColorSet {
  done: string;
  in_progress: string;
  todo: string;
  blocked: string;
}

export const getStatusColors = (isDark: boolean): StatusColorSet => {
  const palette = isDark ? CHART_COLORS.dark : CHART_COLORS.light;
  const todoGray = isDark ? CHART_COLORS.gray[500] : CHART_COLORS.gray[400];

  return {
    done: palette.semantic.good,
    in_progress: palette.semantic.neutral,
    todo: todoGray,
    blocked: palette.semantic.bad,
  };
};

export const getStatusColor = (
  status: DashboardStatus,
  isDark: boolean,
): string => {
  return getStatusColors(isDark)[status];
};

export const getAccentColors = (isDark: boolean) => {
  const palette = isDark ? CHART_COLORS.dark : CHART_COLORS.light;

  return {
    blue: palette.blue[1],
    violet: palette['purple-cool'][1],
    green: palette['green-warm'][1],
    amber: palette.orange[1],
  };
};
